import { memo } from 'react'
import {Routes,Route} from 'react-router-dom';
import { Induction,GenerateTranscript,UploadOldApplication} from '.'

const TransInduction = () => {
  return (
    <Routes>
      <Route path="/gen-transcript" element={<GenerateTranscript/>}/>
      <Route index element={<Induction />}/>
      <Route path="/upload-old-application" element={<UploadOldApplication/>}/>
    </Routes>
  )
}

export default memo(TransInduction) 


const DefaultInduction = ()=>{
  return <div>Induction</div>
}